import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const submenuGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "or",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.STRATEGIC_PROJECT,
        },
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.INITIATIVES,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const activitiesGuards = {
  view: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.view,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  edit: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  create: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.create,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
};

export const strategicActivitiesGuards = {
  view: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.view,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.STRATEGIC_ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  edit: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.manage,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.STRATEGIC_ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
  create: [
    hasPermissionGuard({
      actor: {
        modifier: "and",
        permissions: [
          {
            permissionAction: PermissionAction.create,
            objectTypeId: Constants.CONSTANT_PERMISSIONS.STRATEGIC_ACTIVITIES,
          },
        ],
      },
      redirectTo: "/403",
    }),
  ],
};
